<app-loading-spinner *ngIf="loading"></app-loading-spinner>

<section class="bg-gray-50 dark:bg-gray-900 min-h-screen animate__animated animate__fadeIn animate__faster">
  <div class="flex flex-col justify-center px-6 pb-8 pt-2 mx-auto min-h-screen lg:py-0">
    <div class="header container flex items-center gap-2 lg:px-6 py-6">
      <app-system-logo></app-system-logo>
      <div class="divider-header">/</div>
      <div class="title-app">Aurodoc</div>
    </div>
    <div class="container-form flex items-center justify-center w-full flex-grow">
      <div
        class="w-full bg-white rounded-lg shadow dark:border sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700"
      >
        <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
            {{ 'HOME.LOGIN_PAGE.WELCOME BACK' | translate }}
          </h1>
          <form [formGroup]="userDataForm" name="userDataForm" class="space-y-4 md:space-y-6">
            <div>
              <app-input-set
                forLabel="email"
                [label]="'HOME.LOGIN_PAGE.EMAIL' | translate"
                [control]="userDataForm.get('email')"
                [type]="inputType.EMAIL"
                [placeholder]="'HOME.LOGIN_PAGE.EMAIL EXAMPLE' | translate"
                [submitting]="submitting"
                prefix="user"
                [showTextError]="false"
              ></app-input-set>
              <p *ngIf="email.invalid" class="mt-2 text-sm text-red-600 dark:text-red-500">
                {{ emailErrorMessageSubject | async }}
              </p>
            </div>
            <div>
              <app-input-set
                forLabel="password"
                [label]="'HOME.LOGIN_PAGE.PASSWORD' | translate"
                [control]="userDataForm.get('password')"
                [type]="inputType.PASSWORD"
                placeholder="••••••••"
                [submitting]="submitting"
                prefix="lock"
                [showTextError]="false"
              ></app-input-set>
              <p *ngIf="password.invalid" class="mt-2 text-sm text-red-600 dark:text-red-500">
                {{ passwordErrorMessageSubject | async }}
              </p>
            </div>
            <div class="flex items-center justify-between">
              <div class="flex items-start">
                <div class="flex items-center h-5">
                  <input systemCheckbox id="remember" aria-describedby="remember" type="checkbox" class="w-4 h-4" />
                </div>
                <div class="ml-2 text-sm">
                  <label systemLabel for="remember">{{ 'HOME.LOGIN_PAGE.REMEMBER ME' | translate }}</label>
                </div>
              </div>
              <a
                systemLink
                linkType="primary"
                [routerLink]="['/recovery']"
                class="text-system-600 text-sm font-medium hover:underline"
              >
                {{ 'HOME.LOGIN_PAGE.FORGOT PASSWORD' | translate }}
              </a>
            </div>
            <p *ngIf="invalidGlobalMessage" class="mt-2 text-sm text-red-600 dark:text-red-500">
              {{ invalidGlobalMessage }}
            </p>
            <button
              systemButton
              buttonType="primary"
              type="submit"
              (click)="submit(userDataForm)"
              class="w-full text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              {{ 'HOME.LOGIN_PAGE.CONTINUE' | translate }}
            </button>
            <p class="text-sm font-medium text-gray-600 dark:text-gray-500">
              {{ 'HOME.LOGIN_PAGE.DO NOT HAVE ACCOUNT YET' | translate }}
              <a
                systemLink
                linkType="primary"
                [routerLink]="'/register'"
                class="text-system-600 text-sm font-medium hover:underline"
              >
                {{ 'HOME.LOGIN_PAGE.SIGN UP HERE' | translate }}
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
